import { SearchTaskFilter, TaskFilterValuesExternal } from '@askporter/grieg-types';

// an array & type representing only the keys that retrieve their values from the task-filter-values
export type ConfigBasedTaskFilterKeys = keyof Pick<SearchTaskFilter, 'priority' | 'status'>;
export const configBasedTaskFilters: Array<ConfigBasedTaskFilterKeys> = ['priority', 'status'];

// mapping between the task-filter-values endpoint and the task search endpoint
export const taskFilterValuesMapping: Record<
  keyof Omit<TaskFilterValuesExternal, 'taskTypes'>,
  ConfigBasedTaskFilterKeys
> = {
  priorities: 'priority',
  statuses: 'status',
};

// represents the transformed state of items retrieved from task-filter-values
export type TransformedTaskFilterValues = Array<{
  uid?: string;
  displayName: string;
  groupId?: string;
  uidList?: string[];
  count: number;
}>;
